/* Custom */
import "@/ts/utils/disable-hash-jump";

/* Lazyloading */
import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

/* Vue */
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./app.vue";
import SvgVue from "svg-vue3";

import CandidateContact from "@/ts/components/candidate-contact.vue";
import CompanyContact from "@/ts/components/company-contact.vue";
import GeneralContact from "@/ts/components/general-contact.vue";
import HamburgerButton from "@/ts/components/elements/hamburger-button.vue";
import SlideoutNavigation from "@/ts/components/elements/slideout-navigation.vue";
import BlogOverview from "@/ts/components/blog/overview.vue";
import NextSectionArrow from "@/ts/components/elements/next-section-arrow.vue";
import ReferenceSlider from "@/ts/components/references/reference-slider.vue";

createApp(App)
    .use(SvgVue)
    .use(createPinia())
    .component("candidate-contact", CandidateContact)
    .component("company-contact", CompanyContact)
    .component("general-contact", GeneralContact)
    .component("hamburger-button", HamburgerButton)
    .component("slideout-navigation", SlideoutNavigation)
    .component("blog-overview", BlogOverview)
    .component("next-section-arrow", NextSectionArrow)
    .component("reference-slider", ReferenceSlider)
    .mount("#app");

window.onscroll = function () {
    scrollFunction();
};

function scrollFunction() {
    const header = document.querySelector('#header:not(.prevent-scroll)');
    if (!header) {
        return;
    }
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
}
